"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var ripple_1 = require("@material/ripple");
var ToggleButtons = /** @class */ (function (_super) {
    __extends(ToggleButtons, _super);
    function ToggleButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickHandler = function (item) {
            if (item.disabled)
                return;
            if (_this.props.multipleSelection) {
                item.selected = !item.selected;
                _this.fire('change', _this.props.items);
            }
            else if (!item.selected) {
                _this.props.items.forEach(function (item) { return item.selected = false; });
                item.selected = true;
                _this.fire('change', item);
            }
            _this.update(true);
        };
        return _this;
    }
    ToggleButtons.prototype.installed = function () {
        this.shadowRoot.querySelectorAll('.ripple').forEach(function (dom) {
            new ripple_1.MDCRipple(dom);
        });
    };
    ToggleButtons.prototype.render = function (props) {
        var _this = this;
        return omi_1.h("div", { class: "m-root" }, props.items.map(function (item) { return omi_1.h("button", { class: omi_1.classNames("mb-root mtb-root", {
                'selected': item.selected,
                'disabled': item.disabled
            }), tabindex: "0", disabled: item.disabled, onClick: function (_) { return _this.clickHandler(item); }, type: "button" },
            typeof item.icon === 'string' ? omi_1.h("i", { class: 'material-icons' }, item.icon) : omi_1.h("span", { class: "mtb-label" },
                omi_1.h("svg", { class: "msi-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", role: "presentation" },
                    omi_1.h("path", { d: item.path }),
                    omi_1.h("path", { fill: "none", d: "M0 0h24v24H0z" }))),
            !item.disabled && omi_1.h("span", { class: "ripple ripple-surface" })); }));
    };
    ToggleButtons.defaultProps = {};
    ToggleButtons.propTypes = {
        multipleSelection: Boolean,
        items: Array
    };
    ToggleButtons.css = css;
    ToggleButtons = __decorate([
        omi_1.tag('m-toggle-buttons')
    ], ToggleButtons);
    return ToggleButtons;
}(omi_1.WeElement));
exports.default = ToggleButtons;
